import Home from "../_pages/Home";
import TrainModule from "../_pages/TrainModule";
import SessionCategoryManagement from "../_pages/SessionCategoryManagement";
import ReviewManagement from "../_pages/ReviewManagement";
import UserManagement from "../_pages/UserManagement";

const ProtectedRotues = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/train-module",
    element: <TrainModule />,
  },
  {
    path: "/session-category-management",
    element: <SessionCategoryManagement />,
  },
  {
    path: "/review-management",
    element: <ReviewManagement />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
];

export default ProtectedRotues;
